module.exports = __webpack_public_path__ + "img/cement_light_grey_ba_list.52c28ccc.jpg";